import React from 'react';
import workspaceQuery from '../../queries/customer/CustomerWorkspaceQuery.graphql';
import listQuery from '../../queries/customer/CustomerListQuery.graphql';
import instanceQuery from '../../queries/customer/CustomerQuery.graphql';
import documentDefaultQuery from '../../queries/customer/DocumentDefaultQuery.graphql';
import basicQuery from '../../queries/customer/CustomerQueryBasic.graphql';
import defaultQuery from '../../queries/customer/CustomerDefault.graphql';
import mutationQuery from '../../mutations/customer/CustomerMutation.graphql';
import mutationTempQuery from '../../mutations/customer/CustomerTempMutation.graphql';
import aggregateQuery from '../../queries/customer/CustomerAggregateQuery.graphql';
import fragment from '../../fragments/customer/CustomerFragment.graphql';

import auditWorkspace from '../../queries/customer/CustomerAuditWorkspaceQuery.graphql';
import { formActionsForPermissions } from '../../../actions/customer/CustomerAction';
import { workspaceForPermissions } from '../../../actions/customer/CustomerWorkspaceAction';
import { EntityType, IDropdownOptionRenderer } from '../../../@types/entityTypes';
import { DocumentNode } from 'graphql';
import { ICustomer } from '../../schema/p4types';

const CustomerOptionRenderer: IDropdownOptionRenderer = (props: { option: ICustomer }) => {
  const option = props.option;
  return (
    <span>
      {option?.reference} {option?.name}
    </span>
  );
};

const Customer: EntityType & { auditWorkspace: DocumentNode } = {
  type: 'Customer',
  title: 'Customers',
  formTitle: 'Customer',
  formUrl: '/Customers/Customer/Details/',
  workspaceUrl: '/Customers/Customer/Workspace/',
  instance: instanceQuery,
  documentDefault: documentDefaultQuery,
  basic: basicQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: mutationTempQuery,
  notificationKey: 'reference',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
    optionRenderer: CustomerOptionRenderer,
    valueRenderer: CustomerOptionRenderer,
    filterOption: () => true, //Override Default
    remoteFilter: true,
    placeholder: 'Search customers',
    pageView: false,
    asButton: false,
    selectModal: 'CustomerWorkspace',
    sidebarForm: 'CustomerForm',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'CUSTOMERS',
  actions: [...formActionsForPermissions, ...workspaceForPermissions],
  auditWorkspace: auditWorkspace,
};

export default Customer;
